import { FormControl } from '@angular/forms';

export class ApiValidationField {

  private error: string = '';
  private errorValue: any;

  constructor(
    private formControl: FormControl
  ) { }

  public setError(error: string) {
    this.error = error || '';
    this.errorValue = this.formControl.value;

    this.formControl.updateValueAndValidity();
  }

  public hasError(): boolean {
    return (
        '' !== this.error &&
        this.formControl.value === this.errorValue
      );
  }

  public getError(): string {
    if (!this.hasError) {
      return '';
    }

    return this.error;
  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/api-validation/api-validation-field.model.ts